import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { MsalGuard, MsalService } from '@azure/msal-angular';
import { emailFirstSignIn } from '@app/auth-config';
import { concatMap, map } from 'rxjs/operators';

import { AuthenticationService, SIGN_IN_PATH } from '../services/auth.service';

/**
 * Root guard. Email first off: exactly MsalGuard (straight to the B2C sign-in page, as always).
 * Email first on (SSO implementation plan piece 6a): a visitor with no signed-in account goes to Evide's
 * email page instead, which then starts the right sign-in; signed-in visitors carry on.
 */
export const signInGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  if (!emailFirstSignIn) {
    return inject(MsalGuard).canActivate(route, state);
  }

  const msal = inject(MsalService);
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  // Finish any sign-in redirect first (MsalGuard does the same), so a returning sign-in is seen.
  return msal.initialize().pipe(
    concatMap(() => msal.handleRedirectObservable()),
    map(() => {
      if (msal.instance.getAllAccounts().length > 0) {
        return true;
      }
      auth.rememberReturnUrl(state.url);
      return router.parseUrl(SIGN_IN_PATH);
    })
  );
};
